import simg from "../images/service/img-1.jpg";
import simg2 from "../images/service/img-1.jpg";
import simg3 from "../images/service/img-1.jpg";
import simg4 from "../images/service/img-1.jpg";

import sSingleimg1 from '../images/service-single/2.jpg'
import sSingleimg2 from '../images/service-single/3.jpg'


import ins1 from '../images/instragram/14.jpg'
import ins2 from '../images/instragram/13.jpg'
import ins3 from '../images/instragram/15.jpg'
import ins4 from '../images/instragram/16.jpg'


const About = [
    {
        Id: '1',
        sImg:simg,
        sTitle: 'Introduction',
        description:`Otieno M.O Law Advocate is a duly recognized and registered law practice with its offices in Nairobi, Kenya and collaborations across Africa, Europe and the UAE. 
        Otieno M.O Law Advocate aims to provide superior and efficient solutions to our clients and their businesses through our multi-disciplinary approach that draws upon the collective knowledge and resources of each relevant practice area across our different backgrounds as appropriate, to achieve efficient, effective and practical results for our clients.  
        Furthermore, Otieno M.O Law Advocate has established solid contacts with a number of International Legal experts both in Kenya and abroad with a working understanding to avail Consultants and/or collaborate in specialized areas so as to ensure adherence to best practices and in turn, the best service approach to our clients.
        `,
        des2:'The lower-numbered purposes are better understood and practiced',
        des3:'One way to categorize  activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-broken-arm',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins1,
    },
    {
        Id: '2',
        sImg:simg2,
        sTitle: 'Vision',
        description:`To provide superior, efficient and responsive service by recruiting, training and retaining talented Advocates of the High Court and team members dedicated to excellence in client services, while maintaining a collaborative, diverse and inclusive environment, which provides opportunities to drive business growth and productivity.`,
        des2:'The lower-numbered purposes are better understood and practiced',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-family',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins2,
    },
    {
        Id: '3',
        sImg:simg3,
        sTitle: 'Mission',
        description:`Our Mission is to provide our clients with a network of innovative legal solutions, excellent legal representation and a dedication to quality customer service.`,
        des2:'The lower-numbered purposes are better understood and practiced',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-handcuffs',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins3,
    },
    {
        Id: '4',
        sImg:simg4,
        sTitle: 'Guiding Principles',
        description:`
        <h4>Integrity</h4>
        “Doing the right thing” is not just a common phrase for us, it is a primary guide for all our actions.
        <h4>Innovation</h4>
        We grow by developing and adapting to new tools and ideas to drive efficiencies for our clients.
        <h4>Collegiality and Collaboration</h4>
        Our people are our greatest asset. We maintain a culture of decency, friendship and genuinely respect, appreciate and care about each other, and that includes actively and consistently promoting and encouraging help-seeking and self-care.
        <h4>Diversity and Inclusion</h4>
        We endeavor to maintain a diverse and inclusive workspace that builds different perspective, yielding more creativity and better results and favorable outcome for our clients and the firm. Our environment is free from all forms of discrimination and also celebrate the broadest possible spectrum of viewpoints, backgrounds and beliefs.
        <h4>Excellence</h4>
        We are cognizant that our clients must have total trust and confidence in us. We capitalize on our strengths and how to best leverage them for our clients.

        `,
        des2:'The lower-numbered purposes are better understood and practiced',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'fi flaticon-graduation-cap',
        ssImg1:sSingleimg1,
        ssImg2:sSingleimg2,
        sinst:ins4,
    },
]
export default About;
